/*
 * Validates if a URL has the correct format.
 * @param url The URL to validate
 * @returns true if the URL is valid, false otherwise
 */

const validateUrl = (input: string): boolean => {
  if (!input || typeof input !== 'string') return false

  try {
    const trimmed = input.trim()
    const hasProtocol = /^https?:\/\//.test(trimmed)
    const url = new URL(hasProtocol ? trimmed : `https://${trimmed}`)

    // Validar dominio y evitar cosas raras como "localhost", IPs, etc.
    return /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(url.hostname)
  } catch {
    return false
  }
}

export default validateUrl
